<script setup>
import { computed, nextTick, ref, useTemplateRef } from 'vue';

const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
})

const isOpen = ref(false);

function selectOption(option){
    emit('update:modelValue', option);
}

const selectedLabel = computed(() => {
    for(const option of props.options){
        if(option.value === props.modelValue){
            return option.label;
        }
    }

    return '';
})

function close(){
    setTimeout(() => {
        isOpen.value = false;
    }, 100)
}

</script>

<template>
    <div class="Filter tw-relative tw-mb-4">
        <p
            class="theme-label tw-text-left tw-text-14 tw-mb-1 md:tw-mb-2"
            v-t="`website.configurator.label.${props.name}`"
        >
        </p>

        <button
            type="button"
            class="tw-inline-flex tw-w-full tw-justify-between tw-gap-x-1.5 tw-rounded-xs tw-bg-white tw-px-3 tw-py-4 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-100 hover:tw-bg-gray-50"
            id="menu-button"
            aria-expanded="true"
            aria-haspopup="true"
            @click="isOpen ? close() : (isOpen = true)"
            @keydown.window.escape="close()"
            @blur="close()"
        >
            <span v-text="selectedLabel"></span>

            <svg  class="tw--mr-1 tw-h-5 tw-w-5 tw-text-gray-400 tw-transition-transform" :class="isOpen ? 'tw-rotate-180' : ''" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
            </svg>
        </button>

        <div
            class="tw-absolute tw-left-0 tw-w-full tw-z-10 tw-origin-top-left tw-rounded-sm tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-max-h-[300px] tw-overflow-y-auto focus:tw-outline-none tw-transform tw-transition tw-ease-in-out tw-duration-100"
            :class="isOpen ? 'tw-opacity-100 tw-scale-100 tw-pointer-events-auto' : 'tw-opacity-0 tw-scale-95 tw-pointer-events-none'"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="menu-button"
            tabindex="-1"
        >
            <div role="none">
                <button
                    type="button"
                    v-for="option in props.options"
                    :key="option.value"
                    :class="`tw-block tw-w-full tw-text-left tw-px-4 tw-py-2 tw-text-sm tw-text-gray-700 hover:tw-bg-gray-100 option-${option.value}`"
                    role="menuitem"
                    tabindex="-1"
                    @click="selectOption(option.value);"
                >
                    <span v-text="option.label"></span>
                </button>
            </div>
        </div>
    </div>
</template>